import { useTrend, UseTrendReturn } from './useTrend';
import { getCompletedTrend, TrendTimeframeGrain } from '../services/completedTrendApi';
import type { AppliedFiltersSnapshot } from '../OnTimeDispatchDashboard';

export type UseCompletedTrendReturn = UseTrendReturn;

export function useCompletedTrend(
  appliedFilters: AppliedFiltersSnapshot,
  timeframeGrain: TrendTimeframeGrain
): UseCompletedTrendReturn {
  return useTrend(getCompletedTrend, 'Completed % Trend', appliedFilters, timeframeGrain);
}

